module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("def_placeholder_content", [["div",{"class":"icon video"}],["div",{"class":"txt"},[["textNode",{"text":"You haven't added any content yet"}]]],["a",{"class":"mc-btn btn-middle btn-major"},[["span",{},[["textNode",{"text":"Add a Content"}]]]]]]);
fox.registerTemplate("empty_placeholder", [["div",{},[["div",{"class":"amc-empty-placeholder adaptive new-placeholder"},[["div",{"id":"placeholder-content-container","class":"placeholder-content"}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/templates/emptyPlaceholder.tpl
// module id = 236
// module chunks = 2